import { ADD_MULTIPLE_LABELS } from './actiontypes';
import fetchAllEquipTypesActionCreator from './equiptypes';
import fetchAllPointTypesActionCreator from './pointtypes';
import { getAll, updateLabel } from '../../api/Api';

function addMultipleLabelsAction(labels) {
  return {
    type: ADD_MULTIPLE_LABELS,
    labels,
  };
}

function fetchAllLabelsActionCreator() {
  return (dispatch, getState) => {
    const state = getState();
    const labels = state.entities.labels.byName;
    const { jwt } = state.user;

    // if the equiptypes were loaded recently, abort fetch
    if (labels && labels.length > 0) {
      return Promise.resolve();
    }

    const request = getAll(jwt, 'labels').then(
      (response) => {
        dispatch(addMultipleLabelsAction(response));
      },
      // eslint-disable-next-line no-console
      (error) => console.log(error)
    );
    return request;
  };
}

function removeItemOnce(arr, value) {
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}

export function updateLabelAction(labelName, definition, action) {
  return (dispatch, getState) => {
    const state = getState();
    const labels = state.entities.labels.byName;
    const { jwt } = state.user;
    const oldLabel = labels[labelName];
    const newLabel = oldLabel
      ? { ...oldLabel }
      : { name: labelName, point_types: [], equipment_types: [], equipment_sub_types: [] };
    if (definition) newLabel.definition = definition;
    if (action.additions?.ptId) newLabel.point_types.push(action.additions.ptId);
    if (action.additions?.equipId) newLabel.equipment_types.push(action.additions.equipId);
    if (action.additions?.equipSubId)
      newLabel.equipment_sub_types.push(action.additions.equipSubId);
    if (action.subtractions?.ptId) removeItemOnce(newLabel.point_types, action.subtractions.ptId);
    if (action.subtractions?.equipId)
      removeItemOnce(newLabel.equipment_types, action.subtractions.equipId);
    if (action.subtractions?.equipSubId)
      removeItemOnce(newLabel.equipment_sub_types, action.subtractions.equipSubId);

    const updatePoints = action.additions?.ptId ?? action.subtractions?.ptId != null;
    const updateEquip =
      action.additions?.equipId ??
      action.additions?.equipSubId ??
      action.subtractions?.equipId ??
      action.subtractions?.equipSubId != null;

    const request = updateLabel(jwt, newLabel)
      .then((response) => {
        dispatch(addMultipleLabelsAction([response]));
      })
      .then(() => dispatch(fetchAllPointTypesActionCreator(updatePoints)))
      .then(() => dispatch(fetchAllEquipTypesActionCreator(updateEquip)));
    return request;
  };
}

export default fetchAllLabelsActionCreator;
